export function Visible({
  on,
  children,
  className,
}: {
  on: boolean;
  children: React.ReactNode;
  className?: string;
}) {
  if (on) {
    return <div className={className}>{children}</div>;
  }
  return null;
}
